import { render, staticRenderFns } from "./addStreet.vue?vue&type=template&id=c4d6a54c&scoped=true&"
import script from "./addStreet.vue?vue&type=script&lang=js&"
export * from "./addStreet.vue?vue&type=script&lang=js&"
import style0 from "./addStreet.vue?vue&type=style&index=0&id=c4d6a54c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d6a54c",
  null
  
)

export default component.exports